import React from "react";
import { NavLink, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

import LeftNavContent from '../Commons/LeftNavContent';
import CompanyData from '../AccountLaw/CompanyData';
import PayerData from '../AccountLaw/PayerData';
import Staff from '../AccountLaw/Staff';
import StaffCreate from '../AccountLaw/StaffCreate';
import DetailTransaction from '../AccountLaw/DetailTransaction';
import CreateEntity from './CreateEntity';
import EntityBalance from './Balance/EntityBalance';

import { getEmployees, getAdmins, deleteEmployee } from '../../actions/employeesActions';
import { getCompanies, makeInvoiceCompany } from "../../actions/companyActions";
import {whereBallsMove, getToken} from "../../helper";
import CashInEntityModal from "../Profile/Balance/CashInEntityModal";

class Account extends React.Component {
    state = {
        selectedCompany: null,
        successPayData: null,

        delete: {
            show: false,
            type: 'warning',
            user: null,
            title: ''
        },

        putBalance: {
            amount: 0,
            token: null,
            authtoken: '',
            email: '',
            company: null,
            is_need_original: 1,
            email_for_original: '',

            show: false,
            button: false,
            isFetching: false,
            type: 'default',
        },
    }

    deleteEmployee(user) {
        if(!user) return false;

        this.setState({
            delete:{
                ...this.state.delete,
                show: true,
                user,
                title: `Хотите удалить ${user.user && user.user.first_name || ''}?`,
            }
        });
    }

    deleteConfirm() {
        const {user} = this.state.delete;
        if(!user || !user.user) return false;

        const payload = {
            user_id: user.user.id,
            company_id: user.company_id,
        };
        
        this.props.deleteEmployee(
            payload,
            () => {
                this.setState({
                    delete:{
                        ...this.state.delete,
                        type: 'success',
                        title: `Сотрудник был удален.`
                    }
                })
            }
        )
    }

    deleteCancel() {
        this.setState({
            delete:{
                ...this.state.delete,
                show: false,
                type: 'warning',
                user: null,
            }
        });
    }

    handleSelectedCompany(e) {
        this.setState({
            selectedCompany: {
                ...this.state.selectedCompany,
                [e.target.name]: e.target.value
            }
        })
    }

    handleCompany(company, loadData = true) {
        let newState = this.props.company.companies.data.results.filter(item => item.id == company.value);

        if(this.state.selectedCompany && (!newState.length || newState[0].id === this.state.selectedCompany.id) && loadData){
            return false;
        }
        
        this.setState(
            {
                selectedCompany: newState[0]
            },
            () => {
                if(loadData){
                    this.props.getAdmins({company_id: this.state.selectedCompany.id, is_admin: 1});
                    this.props.getEmployees({company_id: this.state.selectedCompany.id})
                }
            }
        )
    }
    
    componentWillMount() {
        const {getCompanies, session} = this.props;

        getCompanies({user_id: session.currentUser.id}, session.token);
    }

    componentWillReceiveProps(nextProps) {
        const {getAdmins, getEmployees, match:{params}} = this.props;
        const {company:{companies}} = nextProps;
        
        if(this.props.company.companies.isFetching !== companies.isFetching
            && companies.data.results.length
            && !this.state.selectedCompany
        ){
            let company = companies.data.results[0];

            if(params.id){
                let newState = companies.data.results.filter(item => item.id == params.id);
                if(newState.length) company = newState[0];
            }

            this.setState(
                {
                    selectedCompany: company
                },
                () => {
                    getAdmins({company_id: this.state.selectedCompany.id, is_admin: 1});
                    getEmployees({company_id: this.state.selectedCompany.id})
                }
            )
        }
    }

    componentDidMount() {
        whereBallsMove(6)
    }

    getValidActive(id) {
        var reg = new RegExp('^\\d+$');
        return reg.test(id);
    }

    makeInvoiceShowPopup() {
        const {session:{currentUser}} = this.props;

        this.setState({
            putBalance: {
                ...this.state.putBalance,
                show: true,
                email: currentUser.username,
                email_for_original: currentUser.username,
            }
        })
    }

    handleAmount(value, field) {
        let newValue = value;

        this.setState({
            putBalance:{
                ...this.state.putBalance,
                [field]: newValue,
            }
        })
    }

    closePutBalance(callback) {
        this.setState({
            successPayData:null,
            putBalance: {
                ...this.state.putBalance,
                authtoken: '',
                show:false,
                isFetching:false,
                type:'default',
                button: false,                
                amount: 0,
                token: null,
                email: '',
                is_need_original: 1,
                email_for_original: '',
            }
        }, () => callback ? callback() : false)
    }

    putBalanceConfirm() {
        const {putBalance, selectedCompany} = this.state;
        const {amount, email, is_need_original, email_for_original} = putBalance;
        let token = new Date().getTime();
        let authtoken = getToken();

        let params = {
            amount,
            token,
            authtoken,
            email,
            company: selectedCompany,
            is_need_original,
            email_for_original,
        };

        this.setState({
            putBalance: {
                ...this.state.putBalance,
                token,
                authtoken,
                isFetching: true,
            }
        }, () => {
            this.props.makeInvoiceCompany(
                params,
                () => this.setState({putBalance:{...this.state.putBalance, type:'success', isFetching:false}}),
               // () => this.setState({putBalance:{...this.state.putBalance, type:'error', isFetching:false}})
            )
        });
    }

    render() {
        const {company:{companies}, employees, match:{params}, session:{currentUser}} = this.props;
        const {employees:{admins}} = this.props;
        const {selectedCompany} = this.state;

        let currentAdmin = admins.results.filter(item => item.user.id === currentUser.id && selectedCompany && selectedCompany.is_admin);

        return (
            <div className="user-container content">

                {/*Удаление сотрудника*/}
                <SweetAlert
                    type={this.state.delete.type}
                    show={this.state.delete.show}
                    confirmBtnCssClass="alert-btn-confirm"
                    cancelBtnCssClass="alert-btn-cancel"
                    showCancel
                    showConfirm={this.state.delete.type === 'success' ? false : true}
                    confirmBtnText={"Продолжить"}
                    cancelBtnText={this.state.delete.type === 'success' ? "Готово" : "Отменить"}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={this.state.delete.title}
                    onConfirm={() => this.deleteConfirm()}
                    onCancel={() => this.deleteCancel()}
                >
                {
                    this.state.delete.text
                    ? <div style={{marginTop:'15px'}}>{this.state.delete.text}</div>
                    : null
                }
                </SweetAlert>

                <CashInEntityModal
                    putBalance={this.state.putBalance}
                    selectedCompany={this.state.selectedCompany}
                    putBalanceConfirm={() => this.putBalanceConfirm()}
                    closePutBalance={() => this.closePutBalance()}
                    handleAmount={(value, field) => this.handleAmount(value, field)}
                />
    
                <LeftNavContent>
                    <h2 className="left-content__title" style={{marginBottom:"25px"}}>Личный кабинет</h2>

                    <div className="radios-slider big-radios-slider">
                        <NavLink exact className="radio" to="/account">
                            <label htmlFor="option1">Физ. лицо</label>
                        </NavLink>
                        <NavLink className="radio active" to="/account/entity">
                            <label htmlFor="option1">Юр. лицо</label>
                        </NavLink>
                    </div>
                    
                    <ul className="menu-content-nav">
                        <NavLink exact to="/account/entity" className={this.getValidActive(params.id) ? 'active' : ''}>
                            Данные организации
                        </NavLink>
                        <NavLink to="/account/entity/payer-data">
                            Данные плательщика
                        </NavLink>
                        <NavLink to="/account/entity/staff">
                            Сотрудники
                        </NavLink>
                        <NavLink to="/account/entity/balance">
                            Баланс
                        </NavLink>
                        <NavLink to="/account/entity/create">
                            Зарегистрировать компанию
                        </NavLink>
                    </ul>
                </LeftNavContent>

                {
                    companies.isFetching
                    ?
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <div className="menu-content-company-data menu-content-item tab-parent screen-bottom-block">
                                <div className="rounded-white-block">
                                    <div className="white-block-content">
                                        <ul className="data-with-labels">
                                            <li>Загружается...</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <Switch>
                                <Route
                                    exact
                                    path="/account/entity/payer-data"
                                    render={(props) =>
                                        <PayerData
                                            {...props}
                                            handleCompany={(company, load) => this.handleCompany(company, load)}
                                            handleSelectedCompany={(e) => this.handleSelectedCompany(e)}
                                            selectedCompany={selectedCompany}
                                            />
                                        }
                                    />
                                <Route
                                    exact
                                    path="/account/entity/staff"
                                    render={(props) =>
                                        <Staff
                                            {...props}
                                            employees={employees}
                                            companies={companies}
                                            handleCompany={(company, load) => this.handleCompany(company, load)}
                                            selectedCompany={selectedCompany}
                                            deleteEmployee={(user) => this.deleteEmployee(user)}
                                            />
                                        }
                                    />
                                <Route
                                    exact
                                    path="/account/entity/staff/create"
                                    render={(props) =>
                                        <StaffCreate
                                            {...props}
                                            employees={employees}
                                            companies={companies}
                                            handleCompany={(company, load) => this.handleCompany(company, load)}
                                            selectedCompany={selectedCompany}
                                            />
                                        }
                                    />

                                <Route
                                    path={`/account/entity/create`}
                                    render={(props) => 
                                        <CreateEntity
                                            {...props}
                                            handleCompany={(company, load) => this.handleCompany(company, load)}
                                            />
                                        }
                                    />

                                <Route
                                    path={`/account/entity/balance`}
                                    render={(props) =>
                                        <EntityBalance
                                            {...props}
                                            selectedCompany={this.state.selectedCompany}
                                            handleCompany={(company, load) => this.handleCompany(company, load)}
                                            showBalancePopup={() => this.makeInvoiceShowPopup()}
                                            currentAdmin={currentAdmin}
                                            />
                                        }
                                    />

                                <Route
                                    exact
                                    path="/account/entity/:id?"
                                    render={(props) =>
                                        <CompanyData
                                            {...props}
                                            handleCompany={(company, load) => this.handleCompany(company, load)}
                                            handleSelectedCompany={(e) => this.handleSelectedCompany(e)}
                                            selectedCompany={selectedCompany}
                                            />
                                        }
                                    />
                            </Switch>
                        </div>
                    </div>
                }
                
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(
    mapStateToProps,
    {
        getCompanies,
        getEmployees,
        getAdmins,
        deleteEmployee,
        makeInvoiceCompany,
    }
)(Account);


// WEBPACK FOOTER //
// ./src/components/Account/EntityContainer.js